import { AxiosInstance } from "axios";
import {
  getRefreshToken,
  removeAllTokens,
} from "@/core/components/auth/services/cookies";
import { refreshToken } from "@/core/components/auth/services";
import { updateUserToken } from "@/core/components/auth/services/cookies";
import { executeQueue, addToQueue, throwQueue } from "./queue";
import { clearAllChatData } from "@/core/utils/chatbot-storage";

const WOBA_BACKEND_ERROR_CODE_REFRESH_TOKEN = 99;
const IGNORE_PATHS = ["/auth/refresh-token"];

let isRefreshing = false;

export function refreshTokenInterceptorResponse(instance: AxiosInstance) {
  return async (error: any) => {
    const originalRequest = error.config;

    if (
      error?.response?.data?.errorCode === WOBA_BACKEND_ERROR_CODE_REFRESH_TOKEN
    ) {
      throw new Error("user not logged");
    }

    if (IGNORE_PATHS.includes(originalRequest?.url || "")) {
      return Promise.reject(error);
    }

    if (error.response?.status === 401 && !originalRequest?._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          addToQueue({
            resolve: (newAccessToken: string) => {
              originalRequest.headers["Authorization"] =
                "Bearer " + newAccessToken;
              originalRequest.headers["auth-token"] = newAccessToken;
              resolve(instance(originalRequest));
            },
            reject,
          });
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        if (!getRefreshToken()) {
          throw new Error("user not logged");
        }

        const { token: newToken, refreshToken: newRefreshToken } =
          await refreshToken();

        updateUserToken(newToken, newRefreshToken);

        instance.defaults.headers["Authorization"] = "Bearer " + newToken;
        instance.defaults.headers["auth-token"] = newToken;

        executeQueue(newToken);

        const newRequest = {
          ...originalRequest,
          headers: {
            ...originalRequest.headers,
            Authorization: "Bearer " + newToken,
            "auth-token": newToken,
          },
        };

        return instance(newRequest);
      } catch (err) {
        throwQueue(err);

        removeAllTokens();

        // Limpar estado do chat da Lia quando o refresh token falha (localStorage e sessionStorage)
        clearAllChatData();

        throw new Error("user not logged");
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  };
}
